module.exports = __webpack_public_path__ + "static/multi-user-07c9dcc81d6b67228142373033962804.gif";